import m from "mithril";
import MessageProvider from "../../../MessageProvider";
import { Location } from "../../../Models";
import { getValueByLang } from "../../../Utils";
import './LocationFilterListComponent.css';

interface Attrs {
    messageProvider : MessageProvider;
    locations : Location[];
    isShowAttraction: boolean;
    onLocationSelected: (location: Location) => void;
}

function LocationFilterListComponent(): m.Component<Attrs> {
    let filterText:string = "";
    let filterRegex: RegExp = new RegExp("", "i");

    let updateFilterText = function(value: string) {
        filterText = value;
        filterRegex = new RegExp(value, "i"); 
    };

    let filterRegxLocation = function(location) {
        let text:string = ""
        if(location.name != undefined){
            text += location.name.en + location.name.my
        }

        if(location.townshipName != undefined){
            text += location.townshipName.en + location.townshipName.my
        }

        if(location.townName != undefined){
            text += location.townName.en + location.townName.my
        }
        return filterRegex.test(text)
    }

    return {
        oncreate(vnode) {
            (<HTMLInputElement>document.getElementById("location-filter-input")).focus();
        },
    
        view(vnode) {
            const {locations, messageProvider, isShowAttraction, onLocationSelected} = vnode.attrs;

            return [
                m("div", {class: "mmd-appbar sticky-top p-2"}, [
                    m("div", {class: "d-flex align-items-center bg-white border rounded"}, [
                       
                        m("div.ml-2 mr-2", [
                            m("i.bi bi-search text-primary")
                        ]),
                        m("input", {
                            id:"location-filter-input", 
                            class : "flex-fill form-control form-control-borderless border-0 box-shadow-none",
                            type : "text", 
                            placeholder : messageProvider.get("location"), 
                            name : "input-location",
                            autocomplete: "off",
                            oninput : function(event) {
                                updateFilterText(event.target.value);
                            }
                        }),
                        (filterText != "")?
                        m("div", {  
                            class: "justify-content-end mr-2 ml-2",
                            onclick: function(event){
                                event.preventDefault();
                                updateFilterText("");
                                (<HTMLInputElement>document.getElementById("location-filter-input")).value = "";
                            }
                        }, 
                        m("i.bi bi-x-lg text-muted")
                        ): null
                    ])
                ]),
                m("div", {class : "row"},[
                    m("table", {class: "table table-hover", id:"locations"},[
                        m("tbody", {},
                            locations.filter(location => filterRegxLocation(location)).map(location =>{
                                return m(LocationComponent, { 
                                    messageProvider: messageProvider,
                                    location: location,
                                    isShowAttraction: isShowAttraction,
                                    onLocationSelected : function() {
                                        onLocationSelected(location);
                                    }
                                });
                            })
                        )
                    ])
                ])
            ] 
        }
    } 
}


var LocationComponent = {
    view(vnode) {
        const {location, messageProvider, isShowAttraction, onLocationSelected} = vnode.attrs;

        return m("tr", {}, [
            m("td", { class : "list",
                onclick : function(event) {
                    onLocationSelected(location);
                }
            }, [
                (location.type == 'TOWN')?
                [
                    m("i.bi bi-geo-alt text-primary px-2"), 
                    m("span.pl-2", getValueByLang(location.name, messageProvider.currentLang))
                ]: [
                    (location.type == 'ATTRACTION')?
                    [
                        m("div.d-flex flex-row", [
                            m("div.pr-2 pt-2", 
                                m("i.bi bi-geo text-primary p-2")
                            ),
                            m("div", [
                                m("div.ellipsis-more-than-one-line", getValueByLang(location.name, messageProvider.currentLang)), 
                                m("div.text-muted", m("small", getValueByLang(location.townName, messageProvider.currentLang)))   
                            ])
                        ]),
                                             
                    ]: [
                        m("div.d-flex flex-row", [
                            m("div.pr-2 pt-2", 
                               m("i.bi bi-buildings text-primary p-2")
                            ),
                            [
                                m("div", [
                                    m("div.ellipsis-more-than-one-line", getValueByLang(location.name, messageProvider.currentLang)),
                                    m("div.text-muted", 
                                        m("small", [
                                            (
                                                (location.townshipName != null)? 
                                                    getValueByLang(location.townshipName, messageProvider.currentLang) + ", "
                                                : ""
                                            ) + getValueByLang(location.townName, messageProvider.currentLang)
                                        ])
                                    )
                                ])
                            ]
                        ])
                    ]
                ]
            ])
        ])
    }
}

export default LocationFilterListComponent;